import React from 'react';
import TextLink from '@components/TextLink';
import PathArrow from '@components/PathArrow';
import onAlbumClick from '../../actions/onAlbumClick';

type Props = {
  albumId?: number;
  albumName?: string;
  parentId?: number;
};

function AlbumPath({ albumId = 0, parentId = 0, albumName = '' }: Props) {
  if (albumId === 0) {
    return <span>根目录</span>;
  }
  return (
    <div className="flex items-center">
      <TextLink
        scheme="light"
        className="mr-10"
        onClick={() => onAlbumClick(parentId)}
      >
        返回上一级
      </TextLink>
      <PathArrow />
      <span className="ml-10 max-w-2xl truncate">{albumName}</span>
    </div>
  );
}

export default AlbumPath;
